import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import { ReactComponent as CloseIcon } from 'icons/components/bufferClose.svg';

import './index.less';
import './themes/default.less';

export default class ItemHuman extends MainComponent {
    static propTypes = {
        active: PropTypes.bool,
        firstRow: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        secondRow: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        iconLeft: PropTypes.element,
        iconRight: PropTypes.element,
        className: PropTypes.string,
        tooltip: PropTypes.string,
        removeTooltip: PropTypes.string,
        removeCb: PropTypes.func,
        firstRowClick: PropTypes.func,
        onClick: PropTypes.func,
        draggable: PropTypes.bool,
    };

    static defaultProps = {
        active: false,
        firstRow: "",
        secondRow: "",
        iconLeft: null,
        iconRight: null,
        className: "",
        tooltip: "",
        removeTooltip: "",
        removeCb: null,
        firstRowClick: null,
        onClick: null,
        draggable: false,
    };

    firstRowClick(e) {
        const { firstRowClick } = this.props;

        if (firstRowClick?.apply) {
            this._helper.stopEvent(e);
            firstRowClick();
        }
    }

    render() {
        const { className, tooltip, iconLeft, iconRight, removeTooltip, removeCb, active, firstRow, secondRow, onClick, draggable, onDragStart } = this.props;
        const props = tooltip ? { "data-tooltip": tooltip } : {};
        const removeProps = removeTooltip ? { "data-tooltip": removeTooltip } : {};
        const firstCl = this.firstRowClick?.apply ? " hand" : "";

        return (
            <div
                className={`itemHuman ${className} flex centerV gap8 text rad4 ${onClick ? "hand" : ""} ${active ? "active" : ""}`}
                {...props}
                draggable={draggable}
                onDragStart={onDragStart}
                onClick={onClick}
            >
                {!!iconLeft && iconLeft}
                <div className="flex1 col flex start">
                    <div className={"firstRow text p1SemiBold" + firstCl} onClick={this.firstRowClick.bind(this)}>{firstRow}</div>
                    <div className="secondRow text p1">{secondRow}</div>
                </div>
                {(!!iconRight && iconRight) || (!!removeCb?.apply && (
                    <CloseIcon className="removeIcon hand" {...removeProps} onClick={e => {
                        this._helper.stopEvent(e);
                        removeCb();
                    }} />
                ))}
            </div>
        );
    }
}
